import { Box } from "@mui/system";
import { SxProps, Theme } from "@mui/material";

interface ChipWrapProps {
    //direction is "row" for chips that read as a sentence and "column" for a
    //table cell that stacks them
    direction?: "row" | "column"
    sx?: SxProps<Theme>
    children?: React.ReactNode
}

//ChipWrap is the flex box that table cells put their chips in. It exists so the
//spacing is one value rather than the same four lines repeated in every cell.
export function ChipWrap(props: ChipWrapProps) {
    return <Box sx={[
        {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "start",
            flexDirection: props.direction || "row",
            gap: "2px",
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}>
        {props.children}
    </Box>;
}

export default ChipWrap;
